// Textos de flotas de taxi/VTC (docs/flotas-drivers). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'en',
  data: {
    DRIVERS_FLEET: {
      MODE: {
        taxi: 'Taxi',
        vtc: 'Private hire (VTC)',
      },
      FLEET_STATUS: {
        draft: 'Sign-up not sent',
        in_review: 'Under review',
        rejected: 'Rejected',
        approved: 'Approved',
        suspended: 'Suspended',
      },
      DOC_STATUS: {
        pending: 'Pending',
        in_review: 'Under review',
        approved: 'Approved',
        rejected: 'Rejected',
        expired: 'Expired',
        expiring_soon: 'Expires soon',
      },
      EXPIRY: {
        none: 'No expiry',
        valid: 'Expires on {{date}}',
        expiring_soon: 'Expires soon: {{date}}',
        expired: 'Expired on {{date}}',
      },
      OWNER_TYPE: {
        fleet: 'Fleet',
        vehicle: 'Vehicle',
        driver: 'Driver',
      },
      DOC_TYPE: {
        billing_info: 'Billing details',
        bank_ownership_certificate: 'Bank account ownership certificate',
        route_sheet_authorization: 'Route sheet authorisation',
        circulation_permit: 'Vehicle registration certificate',
        technical_sheet_itv: 'Technical sheet with valid MOT (ITV)',
        insurance_policy: 'Vehicle insurance policy',
        taxi_municipal_license: 'Municipal taxi licence',
        vtc_transport_card: 'VTC transport card',
        identity: 'Identity verification',
        driving_license: 'Driving licence',
        taxi_driver_card: 'Taxi driver card',
        vtc_driver_permit: 'VTC driver permit',
        social_security_registration: 'Social Security registration',
      },
      REJECTION_REASON: {
        illegible: 'Illegible',
        expired: 'Expired',
        holder_mismatch: 'Holder does not match',
        plate_mismatch: 'Number plate does not match',
        wrong_document: 'Wrong document',
        other: 'Other reason',
      },
      ROLE: {
        fleet_owner: 'Owner',
        fleet_manager: 'Manager',
        fleet_accountant: 'Accountant',
      },
      MEMBERSHIP_STATUS: {
        pending: 'Request pending',
        accepted: 'Accepted',
        rejected: 'Rejected',
        removed: 'Unlinked',
      },
      EMPLOYMENT_TYPE: {
        salaried: 'Employee',
        self_employed: 'Self-employed',
      },
      VEHICLE_STATUS: {
        incomplete: 'Documents missing',
        in_review: 'Under review',
        rejected: 'Rejected',
        approved: 'Approved',
      },
      SHIFT_SLOT: {
        morning: 'Morning',
        afternoon: 'Afternoon',
        night: 'Night',
      },
      UPLOAD: {
        HINT: 'JPG, PNG or PDF, up to 30 MB.',
        SUBMIT: 'Upload',
        RESUBMIT: 'Upload again',
        UPLOADING: 'Uploading…',
        ERROR_TYPE: 'The file must be JPG, PNG or PDF.',
        ERROR_SIZE: 'The file cannot be larger than 30 MB.',
      },
      VIEWER: {
        EMPTY: 'This document has not been uploaded yet.',
        NO_PREVIEW: 'This file cannot be previewed.',
        OPEN: 'Open in a new tab',
      },
      ONBOARDING_STATUS: {
        in_progress: 'Sign-up in progress',
        in_review: 'Under review',
        rejected: 'Something rejected',
        approved: 'Approved',
      },
      WORKING_AS: {
        own_license: 'Own licence',
        fleet_self_employed: 'Self-employed in a fleet',
        fleet_salaried: 'Employee in a fleet',
      },
      DOC_SHORT: {
        circulation_permit: 'Registration',
        technical_sheet_itv: 'MOT',
        insurance_policy: 'Insurance',
        taxi_municipal_license: 'Licence',
        vtc_transport_card: 'VTC card',
      },
      ADMIN: {
        LOADING: 'Loading…',
        RETRY: 'Retry',
        OPEN: 'Open',
        VIEW: 'View',
        REVIEW_ACTION: 'Review',
        PREVIOUS: 'Previous',
        NEXT: 'Next',
        YES: 'Yes',
        NO: 'No',
        MODE_ALL: 'Taxi and private hire',
        MODE_ARIA: 'Taxi or private hire',
        REGION_ALL: 'All regions',
        REGION_ARIA: 'Region',
        COL_MODE: 'Mode',
        COL_REGION: 'Region',
        COL_STATUS: 'Status',
        COL_CREATED: 'Signed up',
        CAN_WORK: 'Can work',
        OWN_LICENSE: 'Own licence',
        DOCS_APPROVED: '{{approved}} of {{total}} approved',
        DOCS_IN_REVIEW: '{{count}} under review',
        DOCS_REJECTED: '{{count}} rejected',
        BILLING: 'Billing',
        BILLING_LEGAL_NAME: 'Company name',
        BILLING_TAX_ID: 'Tax ID',
        BILLING_ENTITY: 'Invoices as',
        BILLING_ENTITY_company: 'Company',
        BILLING_ENTITY_self_employed: 'Self-employed',
        BILLING_ADDRESS: 'Registered address',
        BILLING_VAT: 'VAT scheme',
        BILLING_NONE: 'Billing details not filled in yet.',
        VAT_general: 'Standard',
        VAT_simplified: 'Simplified',
        VAT_exempt: 'Exempt',
        REVIEWS: {
          TABS_ARIA: 'Review status',
          TAB_IN_REVIEW: 'Pending',
          TAB_APPROVED: 'Approved',
          TAB_REJECTED: 'Rejected',
          PANEL_TITLE_in_review: 'Pending review',
          PANEL_TITLE_approved: 'Approved documents',
          PANEL_TITLE_rejected: 'Rejected documents',
          PANEL_SUB_in_review: 'Those waiting longest come first. Opening one shows the file next to its details.',
          PANEL_SUB_approved: 'Documents already approved, with their expiry date.',
          PANEL_SUB_rejected: 'Rejected documents and the reason given to the user.',
          SEARCH: 'Search fleet, driver or number plate',
          OWNER_ALL: 'Uploaded by: all',
          OWNER_ARIA: 'Uploaded by',
          TYPE_ALL: 'All documents',
          TYPE_ARIA: 'Document type',
          SORT_OLDEST: 'Oldest first',
          SORT_NEWEST: 'Newest first',
          SORT_ARIA: 'Order',
          COL_DOCUMENT: 'Document',
          COL_OWNER: 'Owner',
          COL_OWNER_TYPE: 'Type',
          COL_UPLOADED: 'Uploaded',
          VERSION: 'Version {{version}}',
          OWN_LICENSE_OF: 'Own licence of {{name}}',
          EMPTY_in_review: 'There are no documents pending review.',
          EMPTY_approved: 'No documents have been approved yet.',
          EMPTY_rejected: 'There are no rejected documents.',
          EMPTY_FILTERED: 'No documents match the filters.',
          LOAD_ERROR: 'The documents could not be loaded.',
          SHOWING: 'Showing {{shown}} of {{total}} documents',
          PER_PAGE: '{{count}} per page',
          PER_PAGE_ARIA: 'Documents per page',
        },
        REVIEW: {
          TITLE: 'Document review',
          BACK: 'Back to the queue',
          NEXT_PENDING: 'Next pending',
          LOAD_ERROR: 'The document could not be loaded.',
          DOCUMENT: 'Document',
          UPLOADED: 'Uploaded on {{date}} by {{name}}',
          REVIEW: 'Review',
          APPROVE_TITLE: 'Approve',
          APPROVE_HELP_NONE: 'This document has no expiry date or number: just check that it is correct.',
          EXPIRES_AT: 'Expiry date',
          EXPIRES_HINT: 'Used to warn the fleet that it expires soon or has expired.',
          EXPIRES_REQUIRED: 'Enter the expiry date.',
          LICENSE_NUMBER: 'Licence number',
          AUTHORIZATION_NUMBER: 'Authorisation number',
          LICENSE_REQUIRED: 'Enter the number shown on the document.',
          APPROVE: 'Approve document',
          APPROVING: 'Approving…',
          REJECT_TITLE: 'Reject',
          REASON: 'Reason',
          REASON_PLACEHOLDER: 'Choose a reason',
          REASON_REQUIRED: 'Choose the reason for rejecting it.',
          COMMENT: 'Comment',
          COMMENT_PLACEHOLDER: 'What needs fixing, in one sentence.',
          COMMENT_HINT: 'The user will see it next to the reason.',
          COMMENT_REQUIRED: 'With «Other reason», explain what is wrong.',
          REJECT: 'Reject document',
          REJECTING: 'Rejecting…',
          DONE_APPROVED: 'Document approved. The user has been notified.',
          DONE_REJECTED: 'Document rejected. The user has been notified with the reason.',
          NO_MORE_PENDING: 'There are no more pending documents.',
          ALREADY_REVIEWED: 'Someone else had already reviewed this document. Their decision is shown.',
          ACTION_ERROR: 'The review could not be saved.',
          REVIEWED_BY: 'Reviewed by',
          OWNER: 'Whose it is',
          IDENTITY: 'Identity (Tecalis)',
          IDENTITY_BY: 'on {{date}}',
          IDENTITY_NONE: 'Not verified yet',
          HISTORY: 'History',
          HISTORY_uploaded: 'Uploaded by {{name}}',
          HISTORY_approved: 'Approved by {{name}}',
          HISTORY_rejected: 'Rejected by {{name}}',
          PREVIOUS_VERSIONS: 'Previous versions',
        },
        FLEETS: {
          TABS_ARIA: 'Fleet status',
          TAB_ALL: 'All',
          PANEL_TITLE: 'All fleets',
          PANEL_SUB: 'A fleet can work once all its company documents are approved.',
          SEARCH: 'Search by name, email or code',
          COL_FLEET: 'Fleet',
          COL_VEHICLES: 'Vehicles',
          COL_DRIVERS: 'Drivers',
          COL_REQUESTS: 'Requests',
          EMPTY: 'No fleets match.',
          LOAD_ERROR: 'The fleets could not be loaded.',
          SHOWING: 'Showing {{shown}} of {{total}} fleets',
          PER_PAGE: '{{count}} per page',
          PER_PAGE_ARIA: 'Fleets per page',
        },
        FLEET: {
          APPROVE_BILLING: 'Approve details',
          REJECT_BILLING: 'Reject',
          CONFIRM_REJECT_BILLING: 'Reject billing details',
          TITLE: 'Fleet profile',
          BACK: 'Back to fleets',
          LOAD_ERROR: 'The fleet could not be loaded.',
          CODE: 'Code',
          SUBMITTED: 'Sent for review',
          NOT_SUBMITTED: 'Not sent',
          ONBOARDING: 'Fleet sign-up',
          ONBOARDING_SUB: 'Billing details and company documents.',
          VEHICLES: 'Vehicles',
          VEHICLES_SUB: 'A vehicle can work once all its documents are approved and up to date.',
          NO_VEHICLES: 'No vehicles registered yet.',
          PLATE: 'Number plate',
          CAR: 'Vehicle',
          DOCUMENTS: 'Documents',
          DRIVERS: 'Drivers',
          DRIVERS_SUB: 'Linked with the fleet code.',
          NO_DRIVERS: 'No drivers linked yet.',
          RELATION: 'Relationship',
          SHARE: 'Share',
        },
        DRIVERS: {
          TABS_ARIA: 'Sign-up status',
          TAB_ALL: 'All',
          PANEL_TITLE: 'All drivers',
          PANEL_SUB: 'A driver cannot go online until all their steps are approved.',
          SEARCH: 'Search by name, email, phone or fleet',
          WORKING_AS_ALL: 'How they work: all',
          WORKING_AS_ARIA: 'How they work',
          COL_WORKING_AS: 'How they work',
          COL_STEPS: 'Steps',
          EMPTY: 'No drivers match.',
          LOAD_ERROR: 'The drivers could not be loaded.',
          SHOWING: 'Showing {{shown}} of {{total}} drivers',
          PER_PAGE: '{{count}} per page',
          PER_PAGE_ARIA: 'Drivers per page',
        },
        DRIVER: {
          TITLE: 'Driver profile',
          BACK: 'Back to drivers',
          LOAD_ERROR: 'The driver could not be loaded.',
          VIEW_USER: 'View user profile',
          DOCUMENTS: 'Sign-up steps',
          DOCUMENTS_SUB: 'Documents uploaded from the app.',
          OWN_VEHICLE: 'Of their vehicle',
          IDENTITY_TECALIS: 'Verified by Tecalis',
          FLEETS: 'Fleets',
          NO_FLEETS: 'Has not been in any fleet.',
        },
      },
      HUB: {
        SECTION: 'Taxi and private hire fleets',
        NEW_SECTION: 'New taxi or private hire fleet',
        CREATE_TITLE: 'Register a fleet',
        CREATE_META: 'Manage your taxi or private hire licences, vehicles and drivers.',
      },
      SIGNUP: {
        TITLE: 'Fleet sign-up',
        SUBTITLE: 'Register your taxi or private hire company. You will add vehicles and drivers later from the panel.',
        BACK_TO_HUB: 'Back to the board',
        BACK: 'Back',
        STEP_OF: 'Step {{step}} of {{total}}',
        NEXT: 'Next',
        CREATE: 'Create the fleet',
        CREATING: 'Creating…',
        START_TITLE: 'Your company',
        START_SUB: 'Where you work and how we contact you.',
        NAME: 'Fleet name',
        NAME_HINT: 'The name your drivers will see.',
        NAME_REQUIRED: 'Enter the fleet name.',
        REGION: 'City',
        REGION_PLACEHOLDER: 'Choose the city',
        REGION_REQUIRED: 'Choose the city where the fleet works.',
        EMAIL: 'Company email',
        EMAIL_HINT: 'We will let you know about the document review there.',
        EMAIL_INVALID: 'Enter a valid email.',
        CATALOG_ERROR: 'The cities could not be loaded.',
        ACTIVITY_TITLE: 'What does the fleet do?',
        ACTIVITY_SUB: 'A fleet is either taxi or private hire: it decides which documents are required.',
        ACTIVITY_REQUIRED: 'Choose what the fleet does.',
        MODE_NOTE_TITLE: 'It cannot be changed later',
        MODE_NOTE_TEXT: 'Taxi and private hire are not mixed in the same fleet. If you do both, register one fleet for each.',
        CREATE_ERROR: 'The fleet could not be created.',
      },
      ONBOARDING: {
        SUBTITLE_DRAFT: 'Complete the steps and send them for review. Vehicles are added later, from the panel.',
        SUBTITLE_SENT: 'The status of each step of your sign-up.',
        GO_TO_PANEL: 'Go to the panel',
        PROGRESS: '{{done}} of {{total}} steps completed',
        CATALOG_ERROR: 'The sign-up details could not be loaded.',
        STEP_HINT_billing_info: 'Entity, company name, tax ID, address and VAT.',
        STEP_HINT_bank_ownership_certificate: 'In the company name with the IBAN visible.',
        STEP_HINT_route_sheet_authorization: 'Authorise WAIIS in the Ministry VTC Register.',
        STEP_pending: 'Pending',
        STEP_ready: 'Ready',
        STEP_in_review: 'Under review',
        STEP_approved: 'Approved',
        STEP_rejected: 'Rejected',
        STATUS_TITLE_draft: 'Sign-up not sent',
        STATUS_TITLE_in_review: 'Fleet under review',
        STATUS_TITLE_rejected: 'Something needs fixing',
        STATUS_TITLE_approved: 'Fleet approved',
        STATUS_TITLE_suspended: 'Fleet suspended',
        STATUS_TEXT_draft: 'Complete the steps and send the sign-up.',
        STATUS_TEXT_in_review: 'We are reviewing your documents. Meanwhile you can use the panel, but your drivers cannot go online until the fleet is approved.',
        STATUS_TEXT_rejected: 'Check the rejected step, fix what is indicated and upload it again.',
        STATUS_TEXT_approved: 'Your fleet is approved. You can start working with it.',
        STATUS_TEXT_suspended: 'Contact WAIIS to reactivate it.',
        REJECTED_FIX: 'Fix it and upload it again.',
        LOCKED_STEP: 'This step has been sent. If we reject it, you will be able to upload it again.',
        ENTITY_REQUIRED: 'Choose whether you invoice as a company or as self-employed.',
        FIELD_REQUIRED: 'This field is required.',
        TAX_ID_INVALID: 'The tax ID must have 9 characters.',
        POSTAL_CODE: 'Postcode',
        POSTAL_CODE_INVALID: 'The postcode has 5 digits.',
        CITY: 'Town',
        PROVINCE: 'Province',
        VAT_PLACEHOLDER: 'Choose the VAT scheme',
        SAVE: 'Save details',
        SAVING: 'Saving…',
        SAVE_ERROR: 'The details could not be saved.',
        UPLOAD_ERROR: 'The document could not be uploaded.',
        BANK_TEXT: 'Upload the ownership certificate of the company bank account. It must be in the company name and show the full IBAN.',
        ROUTE_SHEET_TEXT: 'To issue the route sheets for your services, authorise WAIIS in the Ministry VTC Register and upload a screenshot of the authorisation.',
        MISSING_STEPS: 'Complete all the steps to send the sign-up.',
        SUBMIT: 'Send for review',
        SUBMITTING: 'Sending…',
        SUBMIT_ERROR: 'The sign-up could not be sent.',
      },
      OVERVIEW: {
        SUBTITLE: 'The key facts about your fleet at a glance.',
        SEE_ONBOARDING: 'See the sign-up',
        CODE_TITLE: 'Fleet code',
      },
    },
    // Menú y cabeceras de Admin › Taxi y VTC (se fusionan con los generales).
    SIDEBAR: {
      FLEET_SECTION: 'My fleet',
      FLEET_ONBOARDING: 'Fleet sign-up',
      FLEET_OVERVIEW: 'Overview',
      FLEET_DRIVERS: 'Drivers',
      FLEET_VEHICLES: 'Vehicles',
      FLEET_SHIFTS: 'Shifts',
      FLEET_DOCUMENTS: 'Documents',
      FLEET_MONEY_SECTION: 'Money',
      FLEET_SETTLEMENTS: 'Settlements',
      FLEET_REPORTS: 'Reports',
      FLEET_ADMIN_SECTION: 'Administration',
      FLEET_TEAM: 'Team',
      FLEET_SETTINGS: 'Settings',
      FLEET_LOCKED_DRAFT: 'Complete and send the fleet sign-up to use this section.',
      DRIVERS_PRO: 'Taxi and private hire',
      DOCUMENT_REVIEWS: 'Document verification',
      FLEETS: 'Fleets',
      PROFESSIONAL_DRIVERS: 'Professional drivers',
    },
    PAGE_HEADER: {
      DOCUMENT_REVIEWS: 'Manually review the documents uploaded by taxi and private hire fleets and drivers. ID cards are verified by Tecalis.',
      FLEETS: 'Registered taxi and private hire fleets, with their review status, vehicles and drivers.',
      PROFESSIONAL_DRIVERS: 'Taxi and private hire drivers with their own licence or linked to a fleet, and the status of their sign-up.',
    },
  },
};
